/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Office365ToNutshell from './icon-office-365-to-nutshell.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    if (validProps.width && validProps.height) {
        delete validProps.height;
    }

    return <Office365ToNutshell {...validProps} />;
}
SvgComponent.iconName = 'office365ToNutshell';

export const Office365ToNutshellIcon = svgIconWrapper(SvgComponent);
